import React, {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Link, Box, Stack, imageListClasses } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

export const ConversationComponent = forwardRef((props, ref) => {
  const [autoScroll, setAutoScroll] = useState(true);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
  const [scrollDown, setScrollDown] = useState(true);
  const [blockScroll, setBlockScroll] = useState(false);
  const [initChat, setInitChat] = useState(true);
  let lastRef = useRef(null);
  useImperativeHandle(ref, () => ({
    onClick() {
      scrollToBottom();
    },
  }));

  // useEffect(() => {
  //   if (shouldAutoScroll && lastRef.current) {
  //     lastRef.current.scrollIntoView();
  //     setShouldAutoScroll(false); // Desactivamos el scroll automático después de hacerlo
  //   }
  // }, [props.messages, shouldAutoScroll]);
  useEffect(() => {
    if (shouldAutoScroll && lastRef.current) {
      lastRef.current.scrollIntoView();
      setShouldAutoScroll(false); // Desactivamos el scroll automático después de hacerlo
    }
  }, [props.messages, shouldAutoScroll]);

  const bubbleStyle = (isAdmin) => {
    let style = {
      bgcolor: "#FFF",
    };
    if (isAdmin) {
      style.color = "white";
    }
    return style;
  };

  const textStyle = (user, identifier) => {
    let style = {};
    if (identifier.includes("admin")) {
      let adminUser = identifier.split("_")[0];
      style.textAlign = user === adminUser ? "right" : "left";
      style.fontSize = 18;
    } else {
      style.textAlign = user === identifier ? "right" : "left";
    }
    return style;
  };

  const formatText = (user, messageUser, message) => {
    let text = message;
    let view = null;
    const matches = message.match(/{{(.*?)}}/g);

    if (matches) {
      const extractedTexts = matches.map((match) => match.slice(2, -2)); // Remueve las llaves
      text = text.replace(`{{${extractedTexts}}}`, String());
      view = (
        <Link href={extractedTexts[0]} target="_blank">
          {extractedTexts[0]}
        </Link>
      );
    }

    return (
      <Typography
        sx={{
          mr: 3,
          ml: 3,
          color: "primary.main",
          fontWeight: "bold",
          fontSize: 12,
          ...textStyle(user, messageUser),
        }}
      >
        <span style={{ display: "inline", fontWeight: "bold", color: "#000" }}>
          {messageUser.includes("admin")
            ? `Admin - ${messageUser.split("_")[0]}`
            : messageUser.split("_")[0]}
        </span>
        {`: ${text}`}
        {view}
      </Typography>
    );
  };

  const renderMessages = () => {
    return props.messages.map((option, index) => {
      return (
        <Box
          ref={lastRef}
          key={option.identifier}
          sx={bubbleStyle(option.user.includes("admin"))}
        >
          <Divider />
          {/* <Typography
            sx={{
              fontSize: 12,
              mr: 3,
              ml: 3,
              ...textStyle(props.user, option.user),
            }}
          >
            {option.user.split("_")[0]}
          </Typography> */}
          {formatText(props.user, option.user, option.message)}
          {/* <Typography
            sx={{
              mr: 3,
              ml: 3,
              fontWeight: "bold",
              fontSize: 21,
              ...textStyle(props.user, option.user),
            }}
          >
            {option.message}
          </Typography> */}
        </Box>
      );
    });
  };

  const handleScroll = (event) => {
    const scrollContainer = event.target;
    const isScrolledToBottom =
      scrollContainer.scrollHeight - scrollContainer.scrollTop ===
      scrollContainer.clientHeight;

    if (isScrolledToBottom) {
      setShouldAutoScroll(true); // Solo activar el scroll automático cuando el usuario está en la parte inferior
    }
  };

  const scrollToBottom = () => {
    if (lastRef.current) {
      lastRef.current.scrollIntoView();
      setShouldAutoScroll(false); // Desactivamos el scroll automático después de hacerlo
    }
  };
  return (
    <Stack
      spacing={1}
      sx={{
        overflow: "auto",
        maxHeight: { xs: "25vh", sm: "65vh" },
      }}
      onScroll={handleScroll}
    >
      {renderMessages()}
    </Stack>
  );
});
